import { render } from "./PlatformOne.vue?vue&type=template&id=559eb2b2"
import script from "./PlatformOne.vue?vue&type=script&lang=js"
export * from "./PlatformOne.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__